module.exports = __webpack_public_path__ + "static/woonkamer-f871545adfc2a61ca02925207c4722b3.jpg";